import { Component, input, model } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LowerCasePipe } from "@angular/common";
import { ELocalizationLang } from "@shared-core/enums/localization-lang.enum";
import { SelectModule } from "primeng/select";

@Component({
  selector: "app-select-preferred-lang",
  imports: [FormsModule, SelectModule, LowerCasePipe],
  templateUrl: "./select-preferred-lang.component.html",
  styleUrl: "./select-preferred-lang.component.scss",
})
export class SelectPreferredLangComponent {
  langs = input.required<any[] | undefined>();
  selectedLang = model<{ name: string; code: ELocalizationLang } | undefined>(undefined);
}
